module.exports = __webpack_public_path__ + "assets/b5c82d7414064b762e32465d08e4e321.png";